import { action } from 'typesafe-actions';
import { UserTypes } from './types';

export const displayUserInfo = (name: string) =>
  action(UserTypes.DisplayUserInfo, name);
